module.exports = __webpack_public_path__ + "img/41_14.7c93208a.png";